<template>
  <v-container>
    <h3 class="mb-4">{{ evaluateExpression(model.Caption) }}</h3>
    <p>{{ evaluateExpression(model.Description) }}</p>

    <!-- START Login form START -->
    <default-login v-if="currentLoginMethod === 'defaultLogin'" :model="model" :loading="loading" :disabled="disabled" :isInEditorMode="isInEditorMode" />
    <!-- END Login form END -->

    <!--START QRCODE START -->
    <div v-if="currentLoginMethod === 'qr'" class="d-flex align-center justify-center">
      <v-btn v-if="!qrScannerVisible" color="primary" @click="qrScannerVisible = true">{{ $t('login.startScanQr') }}</v-btn>

      <qr-scanner :visible="qrScannerVisible" @decode="decodeQr" @cancel="qrScannerVisible = false" />
    </div>
    <!--END QRCODE END -->

    <!--START SMS_LOGIN START-->
    <template v-if="currentLoginMethod === 'Sms'">
      <dr-login-sms-component v-bind="$props" />
    </template>

    <div v-if="currentLoginMethod === 'DigitalCertificate'" class="d-flex justify-center align-center">
      <v-btn @click="authByDigitalSignature" color="primary">{{ $t('login.showDigitalCertificate') }}</v-btn>
    </div>
    <!--END SMS_LOGIN END-->

    <!--START OIDC_LOGIN START-->
    <div v-if="currentLoginMethod === 'SmartId'" class="d-flex align-center justify-center">
      <v-btn v-if="oidcEnabled" color="primary" @click="signInSmartId">{{ $t('login.signInSmartIdButton') }}</v-btn>
      <span v-else>{{ $t('login.smrtIdErr') }}</span>
    </div>
    <!--START OIDC_LOGIN START-->

    <div class="d-flex align-center justify-space-between" style="flex-flow: column">
      <p v-if="isShowLoginWith" class="pt-4 caption">
        {{ $t('login.loginWith') }}
      </p>

      <div class="login-btn-container d-flex justify-center">
        <v-tooltip bottom v-if="isCanShowIcon('DigitalCertificate')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" icon :disabled="loading" @click="currentLoginMethod = 'DigitalCertificate'" v-bind="attrs" v-on="on">
              <v-icon>mdi-fingerprint</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('login.loginByEds') }}</span>
        </v-tooltip>

        <v-tooltip bottom v-if="oidcEnabled && isCanShowIcon('SmartId')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" @click="currentLoginMethod = 'SmartId'" icon v-bind="attrs" v-on="on">
              <v-icon>mdi-cellphone-key</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('login.signInSmartIdButton') }}</span>
        </v-tooltip>

        <v-tooltip v-if="isCanShowIcon('qr')" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" icon :loading="loading" :disabled="loading" @click="currentLoginMethod = 'qr'" v-bind="attrs" v-on="on">
              <v-icon>mdi-qrcode</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('login.loginByQr') }}</span>
        </v-tooltip>

        <v-tooltip v-if="isCanShowIcon('defaultLogin')" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" icon :loading="loading" :disabled="loading" @click="currentLoginMethod = 'defaultLogin'" v-bind="attrs" v-on="on">
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <span>{{$t('login.defaulLogin')}}</span>
        </v-tooltip>

        <v-tooltip bottom v-if="isCanShowIcon('Sms')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" @click="currentLoginMethod = 'Sms'" v-bind="attrs" v-on="on">
              <v-icon>mdi-android-messages</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('login.loginBySMS') }}</span>
        </v-tooltip>
      </div>
    </div>
    <!--START EDS_LOGIN_POPUP START -->
    <eds-create ref="edsCreateDialog" />
    <!--END EDS_LOGIN_POPUP END -->
  </v-container>
</template>

<script>
  import mixin from '../../mixins/base-mixin'
  import inputMixin from '../../mixins/input-mixin'
  import uk from '../../langs/login/uk.json'
  import ru from '../../langs/login/ru.json'
  import en from '../../langs/login/en.json'
  import { listOfLoginMethods } from './listOfLoginMethods'
  

  export default {
    mixins: [mixin, inputMixin],
    props: ['disabled'],
    components: {
      'dr-login-sms-component': () => import('./dr-login-sms-component.vue'),
      'qr-scanner': () => import('../dr-qr-code/components/qr-scanner.vue'),
      'default-login': () => import('./defaultLogin.vue'),
      'eds-create': () => import('../../widgets/dr-eds/components/eds-create/EdsCreate.vue')
    },
    data: () => ({
      allowedAuthTypes: [],
      smsForm: false,
      phone: '',
      qrScannerVisible: false,
      currentLoginMethod: ''
    }),
    watch: {
      isUserAuthenticated(val) {
        if (val) {
          this.$routerCore.RedirectAfterLogin()
        }
      }
    },

    async mounted() {
      // Если мы в режиме редактирвоания, установить дэфолтный экран
      if (this.isInEditorMode) {
        this.currentLoginMethod = 'defaultLogin'
      }
      if (!this.$authCore) {
        return
      }

      if (this.$authCore?.isAuthenticated) {
        this.$routerCore.RedirectAfterLogin()
      }

      const response = await this.$authCore.auth.getAllowedAuthTypes()
      this.allowedAuthTypes = response.AllowedAuthTypes.split(',')

      // Установить начальный экран логина
      this.setInitialLoginMethod()
    },
    computed: {
      // Если заблокированы все методы авторизации кроме одного, который будет отображаться как дэфолтный
      // не показывать надпись войти с помощью
      isShowLoginWith() {
        // методы авторизации с апи + дэфолтный метод по паролю
        const apiAllowedAuthTypes = [...JSON.parse(JSON.stringify(this.allowedAuthTypes)), 'defaultLogin']

        let allLoginMethods = listOfLoginMethods(this)
        // исключаем методы авторизации которые не доступны с апи
        allLoginMethods = allLoginMethods?.filter((e) => apiAllowedAuthTypes.includes(e.value))
        // исключаем методы авторизации которые запретил использовать юзер
        allLoginMethods = allLoginMethods?.filter((e) => !this.model?.DisabledLoginMethods?.includes(e.value))

        // Если доступен лишь один метод авторизации, то вернуть false и не отображать надпись
        return allLoginMethods?.length > 1
      },
      isUserAuthenticated() {
        return this.isInEditorMode ? null : this.$authCore?.isAuthenticated
      },
      loading() {
        return this.$store.getters.getProcessing
      },

      oidcEnabled() {
        return this.isInEditorMode
          ? this.$store.state.appModels.model?.ProjectSecurity?.OidcEnabled || false
          : this.$store.state.appRunner.model.ProjectSecurity.OidcEnabled
      }
    },
    methods: {
      // Получения дэфолтного метода авторизации, если юзер его не задал
      getDefaultLoginMethod() {
        // Если defaultLogin был отключён пользователем, возвращаем первый из доступных нам
        const isDefaultLoginLock = this.model?.DisabledLoginMethods?.includes('defaultLogin')
        const availableDefaultValues = this.allowedAuthTypes.filter((e) => !this.model?.DisabledLoginMethods?.includes(e))

        if (isDefaultLoginLock) {
          // Для Email метода пока нету логики, поэтому чтобы ничего не ломать, возвращаем другое значение
          return availableDefaultValues[0] == 'Email' ? availableDefaultValues[1] : availableDefaultValues[0]
        }

        return 'defaultLogin'
      },
      // Установить начальный экран логина
      setInitialLoginMethod() {
        if (!this.model?.DefaultLoginMethod) {
          this.currentLoginMethod = this.getDefaultLoginMethod()
          return
        }

        // Доступен ли с АПИ, метод авторизации который выбрал пользователь
        const isDefaultLoginMethodExist = this.allowedAuthTypes.includes(this.model.DefaultLoginMethod)

        if (!isDefaultLoginMethodExist) {
          this.currentLoginMethod = 'defaultLogin'
          return
        }
        this.currentLoginMethod = this.model.DefaultLoginMethod
      },

      // Показывать ли кнопку перехода к другому методу авторизации
      isCanShowIcon(method) {
        // Если текущий метод такой же как и кнопка которая к ниму переходит
        if (this.currentLoginMethod === method) {
          return false
        }

        // Текущий метод поддерживается API, если нет, не показывать иконку смены экрана
        // ATTENTION! для метода defaultLogin, это не распространяется
        const isThisMethodAvailableByApi = method === 'defaultLogin' ? true : this.allowedAuthTypes.includes(method)

        if (!isThisMethodAvailableByApi) {
          return false
        }

        // Если юзер не исключал метод к которому перекинет наша иконка, показать её
        if (!this?.model.DisabledLoginMethods || !this.model?.DisabledLoginMethods.length) {
          return true
        }
        // Если Метод по которому мы хотим перейти был выключен юзером, не показывать картинку
        const isThisMethodAvailable = !this.model.DisabledLoginMethods.includes(method)
        return isThisMethodAvailable
      },
      async signInSmartId() {
        const result = this.$authCore.auth.loginByOidc({ lang: this.getCurrentLanguage(), returnUrl: window.location.pathname })
        if (!result.success) {
          this.$store.commit('SET_ERROR', result.errorMessage)
        }
      },
      getCurrentLanguage() {
        switch (this.$i18n.locale) {
          case 'ru':
            return 'ru-RU'
          case 'uk':
            return 'uk-UA'
          default:
            return 'en-US'
        }
      },
      decodeQr(code) {
        this.qrScannerVisible = false
        this.$authCore.SignInByCode({
          code
        })
      },

      async authByDigitalSignature() {
        let authGuid = await this.$authCore.GetAuthGuid()
        let eds = this.$refs.edsCreateDialog
        eds.showDialog = true
        let bytes = new TextEncoder().encode(new Buffer(authGuid).toString('base64'))
        let result = await eds.signFile(bytes)
        if (!result?.Success) {
          return
        }

        await this.$authCore.SignInByDigitalSignature(JSON.stringify({ GUID: authGuid, SIGN: result.Sign }))
      }
    },
    i18n: {
      messages: {
        uk,
        en,
        ru
      }
    }
  }
</script>
<style>
  .login-btn-container {
    width: 100%;
  }
</style>
